(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('BillingFrequency', BillingFrequency);

    BillingFrequency.$inject = ['$resource'];

    function BillingFrequency ($resource) {
        var resourceUrl =  'api/billing-frequencies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
